import { MilestoneStep } from "../models/milestone.model";
import { ListItem } from "../models/ListItem";
import GenericService from "./genericService";
import { httpService } from "./httpService";

interface MilestoneApiResponse {
  isBooked: any;
  isBookingProgress: any;
  isReserved: any;
  isShortlisted: any;
  isPropertyAllocated: boolean;
  success: boolean;
  message: string;
  data: {
    isPropertyAllocated: boolean;
    isShortlisted: boolean;
    isReserved: boolean;
    isBookingProgress: boolean;
    isBooked: boolean;
  };
}

class MilestoneService extends GenericService<MilestoneStep, ListItem> {
  constructor() {
    super("/api/ReservationShortlist");
  }

async getAll(): Promise<MilestoneStep[]> {
  const url = `/api/ReservationShortlist/getUserMilestone`;
  const method = "GET";
  const options = {
    unwrap: true,
    normalize: true,
    toast: false,
  } as any;

  console.group(`[MilestoneService] Request -> ${method} ${url}`);
  console.log("Request options:", options);
  console.log("Request body:", {}); 
  console.groupEnd();

  try {
    const response = await httpService.post<MilestoneApiResponse>(url, {}, options);
    const dataObj = (response as any)?.data ?? (response as any);

    if (!dataObj) {
      console.warn(`[MilestoneService] No data returned from ${url}`);
      return [];
    }

    const d = dataObj as MilestoneApiResponse["data"];

    const milestones: MilestoneStep[] = [
      {
        step: 1,
        label: "Properties Allocated",
        tooltip: "Properties Allocated",
        isCompleted: !!d.isPropertyAllocated,
        isActive: !!d.isPropertyAllocated && !d.isShortlisted,
      },
      {
        step: 2,
        label: "Shortlisted",
        tooltip: "Shortlisted",
        isCompleted: !!d.isShortlisted,
        isActive: !!d.isShortlisted && !d.isReserved,
      },
      {
        step: 3,
        label: "Request Reservation",
        tooltip: "Request Reservation",
        isCompleted: !!d.isReserved,
        isActive: !!d.isReserved && !d.isBookingProgress,
      },
      {
        step: 4,
        label: "Booking In Progress",
        tooltip: "Booking In Progress",
        isCompleted: !!d.isBookingProgress,
        isActive: !!d.isBookingProgress && !d.isBooked,
      },
      {
        step: 5,
        label: "Booking Completed",
        tooltip: "Booking Completed",
        isCompleted: !!d.isBooked,
        isActive: !!d.isBooked,
      },
    ];

    // Log the mapped milestones and details per-step
    console.group(`[MilestoneService] Mapped milestones (${milestones.length})`);
    console.log("Milestones array:", milestones);
    milestones.forEach((m) => {
      console.log(
        `Step ${m.step}: "${m.label}" -> isCompleted: ${m.isCompleted}, isActive: ${m.isActive}`
      );
    });
    console.groupEnd();

    return milestones;
  } catch (error: any) {
    // If httpService returned response metadata on error, print it
    console.error(`[MilestoneService] Error calling ${method} ${url}:`, {
      message: error?.message ?? error,
      response: error?.response ?? null,
    });
    throw error;
  }
}

}

export const milestoneService = new MilestoneService();
